import Vue from 'vue'
import Vuex from 'vuex'
import sessionMixin from '../mixins/sessionMixin'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    isRouterLoading: false,
    isLoading: false,
    snackbar: {
      show: false,
      color: 'info',
      message: ''
    }
  },
  mixins: [sessionMixin],
  mutations: {
    showLoader (state) {
      state.isLoading = true
    },
    hideLoader (state) {
      state.isLoading = false
    },
    showRouterLoader (state) {
      state.isRouterLoading = true
    },
    hideRouterLoader (state) {
      state.isRouterLoading = false
    },
    showSnackbar (state, { color, message }) {
      state.snackbar.color = color
      state.snackbar.message = message
    },
    closeSnackbar (state) {
      state.snackbar.show = false
    }
  }
})

export default store
